





























































































import { Component, Vue } from 'vue-property-decorator';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel } from '@/components';
import { WorkingTable } from '@/http';
import { default as DataPanel } from '@/components/DataPanel.vue';
import publicFunc from '../../../common/util/publicFunc';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        SearchPanel,
        PaginationPanel,
        DataPanel,
    },
})
export default class ApprovalSummary extends Vue {
    public $refs: {
        pagination: HTMLFormElement;
    };
    public publicFunc: any = publicFunc;
    public searchValue: any = {
        deliveryStartTime: '',
        deliveryEndTime: '',
        customerBaseId: '',
        customerBaseName: '',
        isAdmin: null,
        searchUserId: '',
        enterpriseCompanyId: '',
    };

    public rePagin: boolean = false;

    total = 0;

    public timeList = [];

    public loading: boolean = false;

    tableData = [];

    created() {
        this.loadData();
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    public shipDatetimerange(v) {
        if (v) {
            this.searchValue.deliveryStartTime = v[0];
            this.searchValue.deliveryEndTime = v[1];
        } else {
            this.searchValue.deliveryStartTime = null;
            this.searchValue.deliveryEndTime = null;
        }
    }
    public orderRestaurants = [];
    async querySearchAsyncOrder(queryString, cb) {
        this.searchValue.customerBaseId = '';
        let res = await WorkingTable.GetDropDownList({
            name: queryString,
        });
        this.orderRestaurants = [];
        if (res) {
            res.forEach((item) => {
                this.orderRestaurants.push({
                    id: item.id,
                    value: item.customerBaseName,
                    name: item.customerBaseContactName,
                });
            });
            cb(this.orderRestaurants);
        }
    }
    clearAutocompleteOrder() {
        this.searchValue.customerBaseId = '';
    }
    async handleSelectOrder(item, index) {
        this.searchValue.customerBaseId = item.id;
    }

    public searchFunc() {
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        this.loadData();
    }
    public async loadData() {
        this.loading = true;
        try {
            let res = await WorkingTable.GetAuditSummary({
                ...this.searchValue,
                skip: this.searchPagin.skip,
                count: this.searchPagin.count,
            });
            this.tableData = res.data;
            this.$refs.pagination.setNowPage(this.searchPagin.count);
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            let skip = this.searchPagin.skip;
            this.tableData.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.total = res.total;
            this.loading = false;
        } catch {
            this.loading = false;
        }
    }
    async GetExport() {
        await WorkingTable.GetAuditSummaryExport(this.searchValue);
        this.$message.success('导出成功!');
    }
    resetSearchValue() {
        this.searchValue = {
            deliveryStartTime: '',
            deliveryEndTime: '',
            customerBaseId: '',
            customerBaseName: '',
            isAdmin: null,
            searchUserId: '',
            enterpriseCompanyId: '',
        };
        this.timeList = [];
        this.$refs.pagination.resetSize();
        this.$refs.pagination.handleSizeChange(10);
        this.loadData();
    }
}
